var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-style",class:[_vm.btnSize, _vm.btnClass],style:([_vm.btnColor,_vm.btnStyle]),attrs:{"type":_vm.btnType,"disabled":!_vm.touchable},on:{"click":_vm.onConfirm}},[_c('span',[_vm._v(_vm._s(_vm.btnName))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99360650","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/yoButton.vue
// module id = 3aLg
// module chunks = 1